module.exports = __webpack_public_path__ + "img/patronatoKino.95a9c27e.png";